import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

// Arabic is the project default. Browser/OS language is intentionally not
// used to pick the initial language — only a language the user has
// explicitly chosen before (cached in localStorage/cookie by the detector)
// takes precedence over the Arabic default.
const fallbackLng = ["ar"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: false,
    fallbackLng,
    detection: {
      order: ["localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
      checkWhitelist: true,
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    preload: ["en", "ar"],
    ns: "translation",
    backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;